import { FeatureFlag } from '@ps/web-core-enums';
import { select, useDispatch, useFeature } from '@ps/web-core-store';
import type React from 'react';
import { useSelector } from 'react-redux';

import ActiveGamesSubscribe from './ActiveGamesSubscribe';
import ActiveGamesProvider from './providers/ActiveGamesProvider';

const ActiveGamesSubscription: React.FC = () => {
  const enableActiveGamesSubscription = useFeature(FeatureFlag.PKRNavigationActiveTableButton);
  const idpSecondaryLoginEnabled = useFeature(FeatureFlag.IdpSecondaryLoginEnabled);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { activeGames } = useDispatch();

  if (!isAuthenticated) {
    activeGames.clear();
    return null;
  }

  if (!enableActiveGamesSubscription || !idpSecondaryLoginEnabled) return null;

  return (
    <ActiveGamesProvider>
      <ActiveGamesSubscribe />
    </ActiveGamesProvider>
  );
};

export default ActiveGamesSubscription;
